
// MAV Quantity Selector Fix - Disable minus button at minimum quantity
// Prevents rage clicks by giving clear visual feedback when qty cannot go lower
// Deployed: 2026-06-28 | Fixes: 19 rage clicks on /products/pure-dhea-25mg

(function() {
  'use strict';

  function updateMinusButton(wrapper) {
    var input = wrapper.querySelector('[data-quantity-value], input[name="quantity"][type="number"]');
    var minusBtn = wrapper.querySelector('[data-decrease-qty]');
    if (!input || !minusBtn) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;

    if (val <= min) {
      minusBtn.setAttribute('disabled', 'disabled');
      minusBtn.setAttribute('aria-disabled', 'true');
      minusBtn.style.opacity = '0.35';
      minusBtn.style.cursor = 'not-allowed';
      minusBtn.style.pointerEvents = 'none';
    } else {
      minusBtn.removeAttribute('disabled');
      minusBtn.setAttribute('aria-disabled', 'false');
      minusBtn.style.opacity = '';
      minusBtn.style.cursor = '';
      minusBtn.style.pointerEvents = '';
    }
  }

  function initQtyWrappers() {
    var wrappers = document.querySelectorAll('[data-quantity-wrapper], .t4s-quantity-wrapper');
    wrappers.forEach(function(wrapper) {
      // Initial state
      updateMinusButton(wrapper);

      // Watch the input for changes
      var input = wrapper.querySelector('[data-quantity-value], input[name="quantity"][type="number"]');
      if (input) {
        input.addEventListener('input', function() {
          updateMinusButton(wrapper);
        });
        input.addEventListener('change', function() {
          updateMinusButton(wrapper);
        });
      }

      // Watch the plus button to re-enable minus after increment
      var plusBtn = wrapper.querySelector('[data-increase-qty]');
      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          setTimeout(function() { updateMinusButton(wrapper); }, 50);
        });
      }

      // Watch minus button — after it fires, re-check
      var minusBtn = wrapper.querySelector('[data-decrease-qty]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          setTimeout(function() { updateMinusButton(wrapper); }, 50);
        });
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQtyWrappers);
  } else {
    initQtyWrappers();
  }

  // Also re-run after Shopify section renders (theme re-renders on variant change)
  document.addEventListener('shopify:section:load', initQtyWrappers);
  
  // Re-run after a short delay to catch dynamically loaded content
  setTimeout(initQtyWrappers, 1000);
  setTimeout(initQtyWrappers, 2500);

})();



// MAV Button Text Fix 2026-06-29
// Seal Subscriptions changes .t4s-btn-atc_text to "Add one-time purchase" when one-time is selected.
// We rename it to "Buy now" — watching characterData (text node changes only, not attributes).
// Safe: we guard with a value check so setting textContent won't re-trigger the observer.
(function() {
  function fixBtnText(span) {
    if (!span) return;
    var text = span.textContent || '';
    if (text === 'Add one-time purchase') {
      span.textContent = 'Buy now';
    }
  }

  function watchBtnSpans() {
    var spans = document.querySelectorAll('.t4s-btn-atc_text');
    spans.forEach(function(span) {
      // Fix immediately if already showing wrong text
      fixBtnText(span);
      
      // Watch for text changes — characterData only, not attributes
      var obs = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.type === 'characterData') {
            fixBtnText(span);
          } else if (m.type === 'childList') {
            fixBtnText(span);
          }
        });
      });
      obs.observe(span, { characterData: true, childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBtnSpans);
  } else {
    watchBtnSpans();
  }
  // Also run after Seal Subscriptions finishes loading
  setTimeout(watchBtnSpans, 800);
  setTimeout(watchBtnSpans, 2000);
})();


// ============================================================
// MAV FIX #4 — Slideshow full-width link homepage trap
// Intercept clicks on .t4s-full-width-link anchors that point
// to the homepage (href == site origin + "/") and prevent
// navigation. These are misconfigured slide links that cause
// rage clicks because users click the slideshow expecting
// product/content navigation but get sent to the homepage.
// ============================================================
(function() {
  'use strict';
  
  function fixSlideshowLinks() {
    var origin = window.location.origin;
    var homepageUrls = [origin + '/', origin, window.location.protocol + '//' + window.location.host + '/'];
    
    document.querySelectorAll('a.t4s-full-width-link').forEach(function(link) {
      var href = link.href;
      // Check if this link points to the homepage
      if (homepageUrls.indexOf(href) !== -1 || href === '/') {
        // Disable pointer events so it doesn't intercept clicks
        link.style.pointerEvents = 'none';
        link.setAttribute('data-mav-fixed', 'homepage-link-disabled');
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSlideshowLinks);
  } else {
    fixSlideshowLinks();
  }
  
  // Also run after a short delay to catch dynamically rendered slideshows
  setTimeout(fixSlideshowLinks, 1500);
  setTimeout(fixSlideshowLinks, 3000);
})();


// ============================================================
// MAV FIX #5 — Quantity plus button visual feedback
// When the plus button is clicked and the quantity input value
// changes, briefly flash the input to confirm the click
// registered. Reduces rage clicks from users who don't see
// the number change and click again.
// ============================================================
(function() {
  'use strict';
  
  // Add CSS for the flash animation
  var style = document.createElement('style');
  style.textContent = [
    '@keyframes mav-qty-flash {',
    '  0% { background-color: transparent; }',
    '  30% { background-color: #e8f5e9; border-color: #4caf50; }',
    '  100% { background-color: transparent; }',
    '}',
    '.mav-qty-flash { animation: mav-qty-flash 0.4s ease-out !important; }'
  ].join('\n');
  document.head.appendChild(style);
  
  function attachPlusFeedback() {
    document.querySelectorAll('button[data-increase-qty], button.t4s-quantity-selector.is--plus').forEach(function(btn) {
      if (btn.getAttribute('data-mav-plus-wired')) return;
      btn.setAttribute('data-mav-plus-wired', '1');
      
      btn.addEventListener('click', function() {
        // Find the sibling quantity input
        var wrapper = btn.closest('[data-quantity-wrapper], .t4s-quantity-wrapper');
        var input = wrapper ? wrapper.querySelector('.t4s-quantity-input, input[data-quantity-value]') : null;
        if (!input) return;
        
        // Flash the input after a short delay (T4S updates the value async)
        setTimeout(function() {
          input.classList.remove('mav-qty-flash');
          // Force reflow to restart animation
          void input.offsetWidth;
          input.classList.add('mav-qty-flash');
          setTimeout(function() {
            input.classList.remove('mav-qty-flash');
          }, 450);
        }, 50);
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachPlusFeedback);
  } else {
    attachPlusFeedback();
  }
  setTimeout(attachPlusFeedback, 1000);
  setTimeout(attachPlusFeedback, 2500);
})();


// ============================================================
// MAV FIX #6 — Cart Remove Button Reliability + Tap Target
// The .t4s-page_cart__remove anchor (20x20px SVG) is too small
// for mobile taps and the T4S AJAX handler sometimes fails
// silently. This fix:
// 1) Enlarges the tap target to 44x44px (Apple HIG minimum)
// 2) Adds a reliable click handler that falls back to fetch()
//    if the T4S handler doesn't respond within 500ms
// 3) Shows a spinner while removing to prevent rage clicks
// Deployed: 2026-07-13 | Fixes: 29 rage clicks on /cart
// ============================================================
(function() {
  'use strict';

  // Inject CSS for larger tap target + spinner
  var style = document.createElement('style');
  style.textContent = [
    '.t4s-page_cart__remove {',
    '  min-width: 44px !important;',
    '  min-height: 44px !important;',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  padding: 10px !important;',
    '  border-radius: 4px;',
    '  transition: background-color 0.15s ease;',
    '  position: relative;',
    '}',
    '.t4s-page_cart__remove:hover,',
    '.t4s-page_cart__remove:active {',
    '  background-color: rgba(220, 53, 69, 0.08);',
    '}',
    '.t4s-page_cart__remove.mav-removing {',
    '  pointer-events: none;',
    '  opacity: 0.5;',
    '}',
    '.t4s-page_cart__remove.mav-removing svg {',
    '  animation: mav-spin 0.6s linear infinite;',
    '}',
    '@keyframes mav-spin {',
    '  from { transform: rotate(0deg); }',
    '  to { transform: rotate(360deg); }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function handleCartRemove(e) {
    var link = e.target.closest('.t4s-page_cart__remove');
    if (!link) return;

    // Prevent default navigation and double-clicks
    e.preventDefault();
    e.stopPropagation();

    if (link.classList.contains('mav-removing')) return;
    link.classList.add('mav-removing');

    // Extract the item key from data-id or from the href
    var itemKey = link.getAttribute('data-id');
    if (!itemKey) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/id=([^&]+)/);
      itemKey = match ? match[1] : null;
    }

    if (!itemKey) {
      // Fallback: just navigate
      link.classList.remove('mav-removing');
      window.location.href = link.getAttribute('href');
      return;
    }

    // Use Shopify Cart API to remove the item
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    })
    .then(function(cart) {
      // Update cart count in header
      var countEls = document.querySelectorAll('[data-cart-count], .t4s-cart-count');
      countEls.forEach(function(el) { el.textContent = cart.item_count; });

      // Remove the line item row from DOM
      var row = link.closest('.t4s-cartPage__item, [data-cart-item], .t4s-row');
      if (row) {
        row.style.transition = 'opacity 0.2s ease, max-height 0.3s ease';
        row.style.opacity = '0';
        row.style.maxHeight = row.offsetHeight + 'px';
        row.style.overflow = 'hidden';
        setTimeout(function() {
          row.style.maxHeight = '0';
          row.style.padding = '0';
          row.style.margin = '0';
        }, 200);
        setTimeout(function() {
          row.remove();
          // If cart is now empty, reload to show empty cart state
          if (cart.item_count === 0) {
            window.location.reload();
          }
          // Update totals
          updateCartTotals(cart);
        }, 500);
      } else {
        // Fallback: reload the page
        window.location.reload();
      }
    })
    .catch(function(err) {
      console.error('MAV cart remove error:', err);
      link.classList.remove('mav-removing');
      // Fallback to standard navigation
      window.location.href = link.getAttribute('href');
    });
  }

  function updateCartTotals(cart) {
    // Update subtotal display
    var totalEls = document.querySelectorAll('[data-cart-subtotal], .t4s-cart-subtotal, .t4s-cartPage__total-price');
    var formattedTotal = (cart.total_price / 100).toFixed(2);
    totalEls.forEach(function(el) {
      el.textContent = '$' + formattedTotal;
    });
  }

  function init() {
    // Use event delegation on the cart form
    var cartForm = document.querySelector('[data-cart-wrapper], .t4s-cartPage__form, form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('click', handleCartRemove, true);
    }
    // Also attach to document for dynamically loaded carts
    document.addEventListener('click', function(e) {
      if (e.target.closest('.t4s-page_cart__remove')) {
        handleCartRemove(e);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================================
// MAV FIX #7 — Image Zoom / "Click to enlarge" Reliability
// The T4S theme uses t4s_zoom.min.js for product image zoom
// but it sometimes fails to initialize (race condition with
// lazy loading). This fix ensures the zoom handler is bound
// and provides a fallback lightbox if the native zoom fails.
// Deployed: 2026-07-13 | Fixes: 31 rage clicks on image zoom
// ============================================================
(function() {
  'use strict';

  // Inject lightbox CSS
  var style = document.createElement('style');
  style.textContent = [
    '.mav-lightbox-overlay {',
    '  position: fixed;',
    '  top: 0; left: 0; right: 0; bottom: 0;',
    '  background: rgba(0,0,0,0.9);',
    '  z-index: 99999;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  cursor: zoom-out;',
    '  animation: mav-fade-in 0.2s ease;',
    '}',
    '.mav-lightbox-overlay img {',
    '  max-width: 90vw;',
    '  max-height: 90vh;',
    '  object-fit: contain;',
    '  border-radius: 4px;',
    '}',
    '.mav-lightbox-close {',
    '  position: absolute;',
    '  top: 20px; right: 20px;',
    '  color: white;',
    '  font-size: 32px;',
    '  cursor: pointer;',
    '  width: 44px; height: 44px;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  background: rgba(255,255,255,0.1);',
    '  border-radius: 50%;',
    '}',
    '@keyframes mav-fade-in {',
    '  from { opacity: 0; }',
    '  to { opacity: 1; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function openLightbox(imgSrc) {
    var overlay = document.createElement('div');
    overlay.className = 'mav-lightbox-overlay';
    overlay.innerHTML = '<span class="mav-lightbox-close">&times;</span><img src="' + imgSrc + '" alt="Product zoom">';
    overlay.addEventListener('click', function() {
      overlay.remove();
    });
    document.body.appendChild(overlay);
    // Close on Escape
    function onKey(e) {
      if (e.key === 'Escape') {
        overlay.remove();
        document.removeEventListener('keydown', onKey);
      }
    }
    document.addEventListener('keydown', onKey);
  }

  function getFullSizeUrl(img) {
    // Shopify images: replace _WIDTHx or size params with large version
    var src = img.getAttribute('data-zoom') ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-srcset') ||
              img.src || '';
    // Get the highest resolution version
    src = src.split(',').pop().trim().split(' ')[0]; // last srcset entry
    // Remove Shopify size suffix to get original
    src = src.replace(/_\d+x\d*(@\dx)?\./, '.').replace(/\?.*$/, '');
    // If it's a Shopify CDN URL, request a large version
    if (src.indexOf('cdn.shopify.com') >= 0) {
      src = src.replace(/(_\d+x\d*)/, '_1200x');
      if (src.indexOf('_1200x') === -1) {
        // Add size before extension
        src = src.replace(/\.([a-z]+)$/i, '_1200x.$1');
      }
    }
    return src || img.src;
  }

  function initZoomFallback() {
    // Find product media containers that should be zoomable
    var mediaContainers = document.querySelectorAll(
      '.t4s-product__media-item img, ' +
      '.t4s-product__media img, ' +
      '[data-product-media-type="image"] img, ' +
      '.t4s-product__media-list img'
    );

    mediaContainers.forEach(function(img) {
      if (img.getAttribute('data-mav-zoom-bound')) return;
      img.setAttribute('data-mav-zoom-bound', '1');

      // Make it clear the image is clickable
      img.style.cursor = 'zoom-in';

      img.addEventListener('click', function(e) {
        // Check if T4S zoom already handled this (pswp overlay exists)
        var pswp = document.querySelector('.pswp--open, .t4s-pswp--open');
        if (pswp) return; // T4S zoom is working, don't interfere

        // Wait 100ms to see if T4S zoom opens
        setTimeout(function() {
          var pswpAfter = document.querySelector('.pswp--open, .t4s-pswp--open');
          if (!pswpAfter) {
            // T4S zoom didn't open — use our fallback lightbox
            var fullSrc = getFullSizeUrl(img);
            openLightbox(fullSrc);
          }
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomFallback);
  } else {
    initZoomFallback();
  }
  // Re-run after lazy load and section renders
  setTimeout(initZoomFallback, 1500);
  setTimeout(initZoomFallback, 3000);
  document.addEventListener('shopify:section:load', initZoomFallback);
})();

// ============================================================
// MAV FIX #8 — Subscription Frequency Selector Fix
// The Seal Subscriptions widget renders a <select> with class
// .need-click that sometimes doesn't respond to clicks on
// mobile (likely a z-index or pointer-events issue from the
// T4S theme overlay). This fix ensures the select is clickable
// and adds a visual indicator that it's interactive.
// Deployed: 2026-07-13 | Fixes: 12 rage clicks on sub selector
// ============================================================
(function() {
  'use strict';

  var style = document.createElement('style');
  style.textContent = [
    'select.need-click,',
    '.seal-subscription-widget select,',
    '.nav-commerce-panel select {',
    '  position: relative !important;',
    '  z-index: 10 !important;',
    '  pointer-events: auto !important;',
    '  -webkit-appearance: menulist !important;',
    '  appearance: menulist !important;',
    '  opacity: 1 !important;',
    '  min-height: 44px;',
    '  min-width: 120px;',
    '  cursor: pointer;',
    '  touch-action: manipulation;',
    '}',
    '.nav-commerce-panel,',
    '.seal-subscription-widget {',
    '  position: relative !important;',
    '  z-index: 5 !important;',
    '  pointer-events: auto !important;',
    '}',
    '/* Ensure the subscription panel is not covered by other elements */',
    '.t4s-product__info-container .nav-commerce-panel,',
    '.t4s-product__info-container .seal-subscription-widget {',
    '  overflow: visible !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function fixSubscriptionSelects() {
    // Find all subscription-related selects
    var selects = document.querySelectorAll(
      'select.need-click, ' +
      '.seal-subscription-widget select, ' +
      '.nav-commerce-panel select'
    );

    selects.forEach(function(sel) {
      if (sel.getAttribute('data-mav-sub-fixed')) return;
      sel.setAttribute('data-mav-sub-fixed', '1');

      // Remove any overlay elements that might be blocking clicks
      var parent = sel.parentElement;
      if (parent) {
        var overlays = parent.querySelectorAll('[style*="pointer-events: none"], [style*="opacity: 0"]');
        overlays.forEach(function(ov) {
          if (ov !== sel) {
            ov.style.pointerEvents = 'none';
            ov.style.position = 'absolute';
            ov.style.zIndex = '-1';
          }
        });
      }

      // Ensure the select responds to touch
      sel.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      }, { passive: true });

      sel.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      });
    });

    // Also fix the Subscribe & Save panel clickability
    var panels = document.querySelectorAll('.nav-commerce-panel, .seal-subscription-widget');
    panels.forEach(function(panel) {
      if (panel.getAttribute('data-mav-panel-fixed')) return;
      panel.setAttribute('data-mav-panel-fixed', '1');

      // Ensure nothing above it blocks pointer events
      panel.style.position = 'relative';
      panel.style.zIndex = '5';

      // Check if there's an invisible overlay above it
      var rect = panel.getBoundingClientRect();
      var topEl = document.elementFromPoint(rect.left + rect.width/2, rect.top + rect.height/2);
      if (topEl && topEl !== panel && !panel.contains(topEl)) {
        // Something is covering the panel
        topEl.style.pointerEvents = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSubscriptionSelects);
  } else {
    fixSubscriptionSelects();
  }
  // Seal widget loads async — re-run multiple times
  setTimeout(fixSubscriptionSelects, 1000);
  setTimeout(fixSubscriptionSelects, 2000);
  setTimeout(fixSubscriptionSelects, 3500);
  setTimeout(fixSubscriptionSelects, 5000);
  document.addEventListener('shopify:section:load', fixSubscriptionSelects);
})();

// ============================================================
// MAV FIX #9 — My Prenatal Product Page Thumbnail Fix
// The product page has invisible click targets (empty divs)
// that generate rage clicks. This is typically caused by
// thumbnail gallery items that don't have proper click handlers
// or variant selectors that lost their JS binding.
// Deployed: 2026-07-13 | Fixes: 16 rage clicks on My Prenatal
// ============================================================
(function() {
  'use strict';

  function fixProductThumbnails() {
    // Find thumbnail/media items that might be missing click handlers
    var thumbItems = document.querySelectorAll(
      '.t4s-product__media-item, ' +
      '.t4s-product__thumb-item, ' +
      '[data-product-media-type] img, ' +
      '.t4s-product__media-list .t4s-lz--fadeIn'
    );

    thumbItems.forEach(function(item) {
      if (item.getAttribute('data-mav-thumb-fixed')) return;
      item.setAttribute('data-mav-thumb-fixed', '1');

      // Ensure thumbnails are clickable
      if (item.tagName === 'IMG' || item.querySelector('img')) {
        item.style.cursor = 'pointer';

        // If this is a thumbnail, clicking should switch the main image
        item.addEventListener('click', function(e) {
          // Find the parent slider/gallery
          var gallery = item.closest('.t4s-product__media-list, .t4s-product__thumbs');
          if (!gallery) return;

          // Find the corresponding main media item
          var index = Array.from(item.parentElement.children).indexOf(item);
          var mainMedia = document.querySelector('.t4s-product__media-list, .t4s-product__media');
          if (mainMedia) {
            var mainItems = mainMedia.querySelectorAll('.t4s-product__media-item');
            if (mainItems[index]) {
              // Scroll to or activate this media item
              mainItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }
        });
      }
    });

    // Fix variant selectors that might have lost their bindings
    var variantBtns = document.querySelectorAll(
      '[data-swatch-item]:not(.is--enabled), ' +
      '.t4s-product__option-item:not([data-mav-thumb-fixed])'
    );

    variantBtns.forEach(function(btn) {
      btn.setAttribute('data-mav-thumb-fixed', '1');
      btn.style.cursor = 'pointer';
      btn.style.pointerEvents = 'auto';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductThumbnails);
  } else {
    fixProductThumbnails();
  }
  setTimeout(fixProductThumbnails, 1500);
  setTimeout(fixProductThumbnails, 3000);
  document.addEventListener('shopify:section:load', fixProductThumbnails);
})();

// Cache-bust: 1783971155
